(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["articulo-enmadera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.artEnmIniciado) return;
    window.artEnmIniciado = true;

    function progreso() {
      document.querySelectorAll('[data-art-enm]').forEach(function (raiz) {
        var barra = raiz.querySelector('[data-art-progreso]');
        var cuerpo = raiz.querySelector('[data-art-cuerpo]');
        if (!barra || !cuerpo) return;
        var rect = cuerpo.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.5;
        var avance = total > 0 ? (window.innerHeight * 0.5 - rect.top) / total : 1;
        avance = Math.min(Math.max(avance, 0), 1);
        barra.style.setProperty('transform', 'scaleX(' + avance + ')', 'important');
      });
    }

    window.addEventListener('scroll', progreso, { passive: true });
    window.addEventListener('resize', progreso);
    document.addEventListener('DOMContentLoaded', progreso);

    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-art-copiar]');
      if (!boton) return;
      var original = boton.textContent;
      var marcar = function () {
        boton.textContent = boton.dataset.textoCopiado || original;
        setTimeout(function () { boton.textContent = original; }, 2000);
      };
      if (navigator.clipboard) {
        navigator.clipboard.writeText(boton.dataset.url).then(marcar);
      } else {
        var campo = document.createElement('input');
        campo.value = boton.dataset.url;
        document.body.appendChild(campo);
        campo.select();
        document.execCommand('copy');
        campo.remove();
        marcar();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-video"] && !Shopify.designMode) return;
  try {
    
  class BannerVideoControl extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('[data-banner-video-toggle]');
      this.videos = Array.from(this.querySelectorAll('.banner-video__video'));

      if (!this.button || this.videos.length === 0) return;

      this.onToggleClick = this.toggle.bind(this);
      this.button.addEventListener('click', this.onToggleClick);
    }

    disconnectedCallback() {
      if (this.button) this.button.removeEventListener('click', this.onToggleClick);
    }

    toggle() {
      const isPaused = this.button.getAttribute('data-paused') === 'true';

      this.videos.forEach((video) => {
        if (isPaused) {
          video.play();
        } else {
          video.pause();
        }
      });

      this.button.setAttribute('data-paused', (!isPaused).toString());
    }
  }

  customElements.define('banner-video-control', BannerVideoControl);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boton-enmadera-whatsapp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.waEnmIniciado) return;
    window.waEnmIniciado = true;

    function horaActual() {
      var d = new Date();
      return String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    }

    function abrir(raiz) {
      raiz.classList.add('esta-abierto');
      var toggle = raiz.querySelector('[data-wa-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
      var hora = raiz.querySelector('[data-wa-hora]');
      if (hora) hora.textContent = horaActual();
      var input = raiz.querySelector('[data-wa-input]');
      if (input && window.matchMedia('(min-width: 749px)').matches) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }
    }

    function cerrar(raiz) {
      raiz.classList.remove('esta-abierto');
      var toggle = raiz.querySelector('[data-wa-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    }

    document.addEventListener('click', function (evento) {
      var toggle = evento.target.closest('[data-wa-toggle]');
      if (toggle) {
        var raiz = toggle.closest('[data-wa-enm]');
        if (raiz.classList.contains('esta-abierto')) {
          cerrar(raiz);
        } else {
          abrir(raiz);
        }
        return;
      }

      var botonCerrar = evento.target.closest('[data-wa-cerrar]');
      if (botonCerrar) {
        var raizCerrar = botonCerrar.closest('[data-wa-enm]');
        cerrar(raizCerrar);
        var t = raizCerrar.querySelector('[data-wa-toggle]');
        if (t) t.focus();
      }
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      document.querySelectorAll('[data-wa-enm].esta-abierto').forEach(cerrar);
    });

    document.addEventListener('submit', function (evento) {
      var form = evento.target.closest('[data-wa-form]');
      if (!form) return;
      evento.preventDefault();
      var raiz = form.closest('[data-wa-enm]');
      var input = form.querySelector('[data-wa-input]');
      var texto = (input.value || '').trim();
      if (!texto) texto = input.getAttribute('placeholder') || '';
      var extra = raiz.dataset.extra || '';
      if (extra) texto = texto + '\n\n' + extra;
      var url = 'https://wa.me/' + raiz.dataset.numero + '?text=' + encodeURIComponent(texto);
      var ventana = window.open(url, '_blank', 'noopener');
      if (!ventana) window.location.href = url;
      cerrar(raiz);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carrusel-info"] && !Shopify.designMode) return;
  try {
    
  class SeccionAcompanamosCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-acompanamos-carrusel');
      this.section = this.closest('.seccion-acompanamos');
      this.prevButton = this.section ? this.section.querySelector('.seccion-acompanamos-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-acompanamos-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-acompanamos-columna');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-acompanamos-carrusel', SeccionAcompanamosCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colecciones-destacadas"] && !Shopify.designMode) return;
  try {
    
  class SeccionPiezasCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-piezas-carrusel');
      this.section = this.closest('.seccion-piezas');
      this.prevButton = this.section ? this.section.querySelector('.seccion-piezas-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-piezas-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-piezas-tarjeta');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-piezas-carrusel', SeccionPiezasCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-enmadera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.pieEnmIniciado) return;
    window.pieEnmIniciado = true;

    document.addEventListener('click', function (evento) {
      var acordeon = evento.target.closest('[data-pie-acordeon]');
      if (acordeon) {
        var raiz = acordeon.closest('.pie-enm');
        if (!raiz || !raiz.classList.contains('pie-enm--acordeon')) return;
        if (window.matchMedia('(min-width: 749px)').matches) return;
        var columna = acordeon.closest('.pie-enm__columna');
        var abierta = columna.classList.toggle('esta-abierta');
        acordeon.setAttribute('aria-expanded', abierta ? 'true' : 'false');
        return;
      }

      var toggle = evento.target.closest('[data-pie-nl-toggle]');
      if (toggle) {
        var interno = toggle.closest('.pie-enm__nl-interno');
        if (!interno) return;
        interno.classList.add('esta-abierto');
        var campo = interno.querySelector('input[type="email"]');
        if (campo) campo.focus();
      }
    });

    document.addEventListener('change', function (evento) {
      if (evento.target.matches('[data-pie-region]') && evento.target.form) {
        evento.target.form.submit();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-catgoria-enmadera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function moverCajones() {
      document.querySelectorAll('[data-info-cajon]').forEach(function (cajon) {
        if (cajon.parentElement === document.body) return;
        var previo = document.body.querySelector(':scope > #' + CSS.escape(cajon.id));
        if (previo) previo.remove();
        document.body.appendChild(cajon);
      });
    }

    moverCajones();
    document.addEventListener('DOMContentLoaded', moverCajones);
    document.addEventListener('shopify:section:load', moverCajones);

    if (window.infoEnmIniciado) return;
    window.infoEnmIniciado = true;

    var ultimoFoco = null;

    function abrir(cajon, itemId, boton) {
      ultimoFoco = boton;
      cajon.querySelectorAll('[data-info-item]').forEach(function (item) {
        item.hidden = item.getAttribute('data-info-item') !== itemId;
      });
      var panel = cajon.querySelector('.info-enm-cajon__panel');
      var titulo = cajon.querySelector('[data-info-item="' + itemId + '"] .info-enm-cajon__titulo');
      if (panel && titulo) panel.setAttribute('aria-label', titulo.textContent.trim());
      if (panel) panel.scrollTop = 0;
      cajon.classList.add('esta-abierto');
      document.documentElement.classList.add('info-enm-bloqueo');
      var cerrarBtn = cajon.querySelector('.info-enm-cajon__cerrar');
      if (cerrarBtn) setTimeout(function () { cerrarBtn.focus(); }, 50);
    }

    function cerrar(cajon) {
      if (!cajon || !cajon.classList.contains('esta-abierto')) return;
      cajon.classList.remove('esta-abierto');
      document.documentElement.classList.remove('info-enm-bloqueo');
      if (ultimoFoco && document.body.contains(ultimoFoco)) ultimoFoco.focus();
    }

    document.addEventListener('click', function (evento) {
      var botonLeer = evento.target.closest('[data-info-leer-boton]');
      if (botonLeer) {
        var contenedor = botonLeer.closest('[data-info-leer]');
        var abierto = contenedor.classList.toggle('esta-abierto');
        botonLeer.setAttribute('aria-expanded', abierto ? 'true' : 'false');
        return;
      }

      var botonAbrir = evento.target.closest('[data-info-abrir]');
      if (botonAbrir) {
        moverCajones();
        var cajon = document.getElementById(botonAbrir.getAttribute('data-info-cajon-id'));
        if (cajon) abrir(cajon, botonAbrir.getAttribute('data-info-abrir'), botonAbrir);
        return;
      }

      var botonCerrar = evento.target.closest('[data-info-cerrar]');
      if (botonCerrar) cerrar(botonCerrar.closest('[data-info-cajon]'));
    });

    document.addEventListener('keydown', function (evento) {
      if (evento.key !== 'Escape') return;
      document.querySelectorAll('[data-info-cajon].esta-abierto').forEach(cerrar);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["proyectos-enmadera"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function actualizar(raiz) {
      var pista = raiz.querySelector('[data-pro-pista]');
      var prev = raiz.querySelector('[data-pro-prev]');
      var next = raiz.querySelector('[data-pro-next]');
      if (!pista || !prev || !next) return;
      var max = pista.scrollWidth - pista.clientWidth - 2;
      prev.disabled = pista.scrollLeft <= 2;
      next.disabled = pista.scrollLeft >= max;
    }

    function paso(pista) {
      var slide = pista.querySelector('.pro-enm__slide');
      if (!slide) return pista.clientWidth;
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function iniciar() {
      document.querySelectorAll('[data-pro-enm]').forEach(function (raiz) {
        if (raiz.dataset.proIniciado) return;
        raiz.dataset.proIniciado = 'true';
        var pista = raiz.querySelector('[data-pro-pista]');
        if (!pista) return;
        pista.addEventListener('scroll', function () { actualizar(raiz); }, { passive: true });
        window.addEventListener('resize', function () { actualizar(raiz); });
        actualizar(raiz);
      });
    }

    document.addEventListener('click', function (evento) {
      var boton = evento.target.closest('[data-pro-prev], [data-pro-next]');
      if (!boton) return;
      var raiz = boton.closest('[data-pro-enm]');
      var pista = raiz.querySelector('[data-pro-pista]');
      var direccion = boton.hasAttribute('data-pro-next') ? 1 : -1;
      pista.scrollBy({ left: paso(pista) * direccion, behavior: 'smooth' });
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciar);
    } else {
      iniciar();
    }
    document.addEventListener('shopify:section:load', iniciar);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-categorias"] && !Shopify.designMode) return;
  try {
    
  class SeccionCategoriasCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-categorias-carrusel');
      this.section = this.closest('.seccion-categorias');
      this.prevButton = this.section ? this.section.querySelector('.seccion-categorias-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-categorias-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByAmount.bind(this, -1);
      this.onNextClick = this.scrollByAmount.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByAmount(direction) {
      const distance = this.track.clientWidth * 0.6 * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('seccion-categorias-carrusel', SeccionCategoriasCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-galeria-social"] && !Shopify.designMode) return;
  try {
    
  class GaleriaSocialCarrusel extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.track = this.querySelector('.seccion-galeria-social-carrusel');
      this.section = this.closest('.seccion-galeria-social');
      this.prevButton = this.section ? this.section.querySelector('.seccion-galeria-social-flecha--prev') : null;
      this.nextButton = this.section ? this.section.querySelector('.seccion-galeria-social-flecha--next') : null;

      if (!this.track) return;

      this.onPrevClick = this.scrollByCard.bind(this, -1);
      this.onNextClick = this.scrollByCard.bind(this, 1);
      this.onScroll = this.updateButtonsState.bind(this);

      if (this.prevButton) this.prevButton.addEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.addEventListener('click', this.onNextClick);
      this.track.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);

      this.updateButtonsState();
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.onPrevClick);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.onNextClick);
      if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }

    scrollByCard(direction) {
      const card = this.track.querySelector('.seccion-galeria-social-item');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap || 0);
      const distance = (card.getBoundingClientRect().width + gap) * direction;
      this.track.scrollBy({ left: distance, behavior: 'smooth' });
    }

    updateButtonsState() {
      const maxScrollLeft = this.track.scrollWidth - this.track.clientWidth - 1;

      if (this.prevButton) {
        this.prevButton.disabled = this.track.scrollLeft <= 0;
      }

      if (this.nextButton) {
        this.nextButton.disabled = this.track.scrollLeft >= maxScrollLeft;
      }
    }
  }

  customElements.define('galeria-social-carrusel', GaleriaSocialCarrusel);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-info-producto"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function closeOnOverlayClick(event) {
      const overlay = event.target.closest('.seccion-info-producto-modal .modal__overlay');
      if (!overlay) return;

      const modal = overlay.closest('.seccion-info-producto-modal');
      if (!modal) return;

      const closeButton = modal.querySelector('.modal-close-button');
      if (closeButton) {
        closeButton.click();
      }
    }

    document.addEventListener('click', closeOnOverlayClick);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seccion-proceso-etapas"] && !Shopify.designMode) return;
  try {
    
  class ProcesoEtapasAcordeon extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-proceso-etapa]'));
      this.onClick = this.handleClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    handleClick(event) {
      const clicked = event.target.closest('[data-proceso-etapa]');
      if (!clicked) return;

      this.items.forEach((item) => {
        const isActive = item === clicked;
        item.classList.toggle('seccion-proceso-etapas-item--activo', isActive);
        item.setAttribute('aria-expanded', isActive ? 'true' : 'false');
      });
    }
  }

  customElements.define('proceso-etapas-acordeon', ProcesoEtapasAcordeon);

  } catch(e) { console.error(e); }
})();
})();
